module.exports = __webpack_public_path__ + "media/prk/assets/images/Blank-d68e763c825dc0e388929ae1b375ce18.jpeg";